import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import { useTheme } from "../context/ThemeContext";

const Music = () => {
  const { currentTheme } = useTheme();
  const [activeTab, setActiveTab] = useState(0);
  const [activeFamilySubTab, setActiveFamilySubTab] = useState(0);
  const [activeSubTab, setActiveSubTab] = useState(0);

  // Organize songs by category
  const songCategories = [
    {
      category: "Love",
      icon: "❤️",
      hasSubCategories: true,
      subCategories: [
       
        {
          name: "Cheerful",
          icon: "💕",
          songs: [
            {
              title: "Hamesha Tera Rahunga",
              description: "A romantic song expressing eternal love",
              videoId: "cZb0PnFCxr8",
              releaseDate: "2024"
            },
            {
              title: "Kinni Pyari Lagdiye",
              description: "A romantic song expressing first sight love",
              videoId: "ErQRjpGgzQw",
              releaseDate: "2023"
            },
             {
              title: "Dil Karta Hai",
              description: "A romantic song expressing the feelings of the heart",
              videoId: "t5fTq-iDDRw",
              releaseDate: "2016"
            },
             {
              title: "Valentine",
              description: "A romantic song for Valentine's Day",
              videoId: "y0NEq08eIh4",
              releaseDate: "2018"
            },
            {
              title: "Valentine - Acoustic",
              description: "A romantic acoustic version of the Valentine's Day song",
              videoId: "TUdVT4naIgc",
              releaseDate: "2018"
            },
              {
              title: "Valentine - EDM Remix",
              description: "EDM version of the romantic song for Valentine's Day",
              videoId: "EOmRy8ST_-4",
              releaseDate: "2018"
            },
            
          ]
        }, {
          name: "Melancholic",
          icon: "💔",
          songs: [
             {
              title: "Aaja Re Aaja",
              description: "A song about heartbreak and lost love",
              videoId: "JoOc7kQzMjc",
              releaseDate: "2023"
            },
              {
              title: "Jiya Jaye Na",
              description: "A song about longing and yearning in love",
              videoId: "xX0tVMYUnIY",
              releaseDate: "2017"
            }
            ,
              {
              title: "Jiya Jaye Na - Remix",
              description: "A song about longing and yearning in love",
              videoId: "dTIY7R6sLY4",
              releaseDate: "2017"
            }
            
            // Add melancholic/sad love songs here
          ]
        },
      ]
    },
    {
      category: "Family",
      icon: "👨‍👩‍👧‍👦",
      hasSubCategories: true,
      subCategories: [
        {
          name: "Mother",
          icon: "👩",
          songs: [
            {
              title: "Pyari Maa (Soulful Version)",
              description: "A song dedicated to all the amazing mothers out there",
              videoId: "fKJ7TVuPJvA",
              releaseDate: "2023"
            },
            {
              title: "Pyari Maa (Happy Version)",
              description: "A song dedicated to all the amazing mothers out there",
              videoId: "gqZsR2YNmIM",
              releaseDate: "2023"
            }
          ]
        },
        {
          name: "Father",
          icon: "👨",
          songs: [
            {
              title: "Papa Tumsa Na Koi (Female Version)",
              description: "A song dedicated to all the amazing fathers out there",
              videoId: "3szJbZgyjBo",
              releaseDate: "2021"
            },
            {
              title: "Papa Tumsa Na Koi (Male Version)",
              description: "A song dedicated to all the amazing fathers out there",
              videoId: "SAGXI18FqBE",
              releaseDate: "2021"
            }
          ]
        },
        
        {
          name: "Daughter",
          icon: "👧",
          songs: [
            {
              title: "Nanhi Si Bitiya (Male Version)",
              description: "My First Original Song",
              videoId: "oP-jveDW9l8",
              releaseDate: "2020"
            },
            {
              title: "Nanhi Si Bitiya (Female Version)",
              description: "My First Original Song",
              videoId: "bqTyWDroWDc",
              releaseDate: "2025"
            }
          ]
        },
        {
          name: "Son",
          icon: "👦",
          songs: [
            {
              title: "Nanha Sa Beta (Male Version)",
              description: "My First Original Song",
              videoId: "OKC1Cc6pCWQ",
              releaseDate: "2016"
            },
            {
              title: "Nanha Sa Beta (Female Version)",
              description: "My First Original Song",
              videoId: "45GLr-uyEzE",
              releaseDate: "2025"
            },
            {
              title: "Bete Tu Meri Jaan",
              description: "Another song to celebrate the bond between parent and son",
              videoId: "-Dysz0h7urI",
              releaseDate: "2025"
            }
          ]
        }
        
        
      ]
    },
    {
      category: "Friends",
      icon: "🤝",
      songs: [
        {
              title: "Dosti Hai Zindagi",
              description: "A song to celebrate the bond of friendship",
              videoId: "QTAaKx3dlYQ",
              releaseDate: "2020"
            },
            {
              title: "Ladki Ke Sath Jab Hota Hai",
              description: "Teasing a close friend about his crush",
              videoId: "vq4tnsCoAgs",
              releaseDate: "2020"
            }
        // Add friendship songs here
      ]
    },{
      category: "Children",
      icon: "🧒",
      hasSubCategories: true,
      subCategories: [
        {
          name: "Nursery Rhymes",
          icon: "🎵",
          songs: [
             {
          title: "Hathi Raja",
          description: "A fun nursery rhyme about an elephant king",
          videoId: "tSASMIVoMl4",
          releaseDate: "2025"
        },
         {
          title: "Tamatar",
          description: "A fun nursery rhyme about a tomato",
          videoId: "4KHgRKO-0BE",
          releaseDate: "2025"
        }, 
          {
          title: "Barish",
          description: "A fun nursery rhyme about a rainy day",
          videoId: "viN8oaS_UiU",
          releaseDate: "2025"
        },
         {
          title: "Good Morning Song",
          description: "A cheerful nursery rhyme to start the day",
          videoId: "5Zg-42NrKg0",
          releaseDate: "2025"
        },
         {
          title: "Gaana Gayein",
          description: "A fun nursery rhyme about singing songs",
          videoId: "f-snQGr2SSk",
          releaseDate: "2025"
        }, 
          {
          title: "Good Boy Good Girl",
          description: "A cheerful nursery rhyme about good behavior",
          videoId: "xjg0l3kBhXI",
          releaseDate: "2025"
        },
         {
          title: "O Meri Gudiya",
          description: "A fun nursery rhyme about a doll",
          videoId: "MYfjuA7AyOk",
          releaseDate: "2025"
        },{
          title: "Dada Ji",
          description: "A fun nursery rhyme about grandfather",
          videoId: "JI0iRexTeVg",
          releaseDate: "2025"
        }, 
          {
          title: "Chidiya Rani",
          description: "A fun nursery rhyme about a bird queen",
          videoId: "4GhX-k3hkwA",
          releaseDate: "2025"
        },
         {
          title: "Teacher Ji",
          description: "A fun nursery rhyme about a teacher",
          videoId: "Y4QumfLZAnM",
          releaseDate: "2025"
        }
            // Add nursery rhymes here
          ]
        },
        {
          name: "Lullaby",
          icon: "🌙",
          songs: [
             {
          title: "Ragini Lullaby",
          description: "A soothing lullaby to help children sleep",
          videoId: "JbN2kWv6IKo",
          releaseDate: "2023"
        },
         {
          title: "Pari Lullaby",
          description: "A angelic lullaby to help children sleep",
          videoId: "THofbVF_vFk",
          releaseDate: "2023"
        },
         {
          title: "Dhwani Lullaby",
          description: "A calming lullaby to help children sleep",
          videoId: "Jry8bqKLctY",
          releaseDate: "2023"
        },
         {
          title: "Gunjan Lullaby",
          description: "Gentle echoes lullaby to help children sleep",
          videoId: "N77YGHOn1fI",
          releaseDate: "2023"
        },
         {
          title: "Des Lullaby",
          description: "A soothing lullaby based on raga Desh to help children sleep",
          videoId: "01q_FnyYT8w",
          releaseDate: "2023"
        },
         {
          title: "Swara Lullaby",
          description: "A gentle notes lullaby to help children sleep",
          videoId: "FuEl-YYK2HY",
          releaseDate: "2023"
        },
         {
          title: "Lori Lullaby",
          description: "A soothing lullaby to help little babies sleep",
          videoId: "d20lvdpqri4",
          releaseDate: "2023"
        },
         {
          title: "Tarz Lullaby",
          description: "Gentle tune to help children sleep",
          videoId: "vJZZeIxTHrY",
          releaseDate: "2023"
        },
         {
          title: "Venu Lullaby",
          description: "Cocooned in dreams lullaby to help children sleep",
          videoId: "AUz9rPFbzwY",
          releaseDate: "2023"
        },
          {
          title: "Naad Lullaby",
          description: "Awakening of inner peace lullaby to help children sleep",
          videoId: "9quVomhQ0wk",
          releaseDate: "2023"
        }
            // Add lullaby songs here
          ]
        }
        
      ]
    },
    
    {
      category: "Monsoon",
      icon: "🌧️",
      songs: [
        {
          title: "Barish Tham Na Jaye",
          description: "A romantic song for the monsoon season",
          videoId: "TxI9_eGgE5s",
          releaseDate: "2024"
        }, 
           {
          title: "Jhir",
          description: "A soothing song for the monsoon season",
          videoId: "EPJh7WpsNLA",
          releaseDate: "2020"
        },
         {
          title: "Barish Tham Na Jaye - Lofi Remix",
          description: "A lofi remix of the romantic monsoon song",
          videoId: "rS5A2cePQ_Q",
          releaseDate: "2024"
        }
        
      ]
    },
    
    {
      category: "Patriotic",
      icon: "🇮🇳",
      songs: [
         {
          title: "Mera Pyara Bharat",
          description: "A patriotic song expressing love for India",
          videoId: "fn8zJMRj3I4",
          releaseDate: "2025"
        },
         {
          title: "Aye Watan Tu Meri Jaan",
          description: "A patriotic song for people who believe in justice and democracy",
          videoId: "_CRcKokYkLg",
          releaseDate: "2026"
        }
        // Add patriotic songs here
      ]
    },
    
    {
      category: "Rap",
      icon: "🎤",
      songs: [
        {
          title: "Kekda",
          description: "A rap song about people who always pull your leg when they see you succeeding",
          videoId: "FVlB9aKqcsE",
          releaseDate: "2020"
        }
        // Add rap songs here
      ]
    },
    
    {
      category: "Devotional",
      icon: "🙏",
      hasSubCategories: true,
      subCategories: [
        {
          name: "Shiva",
          icon: "🔱",
          songs: [           
            {
              title: "Malang",
              description: "A devotional song expressing spiritual devotion",
              videoId: "htbnX6jEY2M",
              releaseDate: "2025"
            },
            {
              title: "Jhoome Bhole",
              description: "A devotional song expressing spiritual devotion",
              videoId: "-YvEvmyGtfw",
              releaseDate: "2025"
            },
            {
              title: "Shankara",
              description: "Soulful devotional song dedicated to Lord Shiva",
              videoId: "Pyv_nsBTnNI",
              releaseDate: "2025"
            }
          ]
        },
        {
          name: "Ganesha",
          icon: "🐘",
          songs: [
            {
              title: "Ganpati Bappa Mere",
              description: "A devotional edm song for all lord Ganesha devot",
              videoId: "5seIgNvA8d0",
              releaseDate: "2026"
            }
          ]
        },
        {
          name: "Krishna",
          icon: "🦚",
          songs: [
            {
              title: "Karte Ho Tum O Shyam",
              description: "Soulful Lord Krishna devotional song",
              videoId: "vg1jOiGE_6c",
              releaseDate: "2017"
            },
            {
              title: "Jab Koi Nahi Aata",
              description: "Lord Krishna devotional song about seeking divine help in times of need",
              videoId: "cN2Ekv7sleM",
              releaseDate: "2017"
            }

            // Add Krishna devotional songs here
          ]
        },
        {
          name: "Durga",
          icon: "🌺",
          songs: [
               {
              title: "Maa Ka Naam",
              description: "A devotional song telling the power of chanting the name of Goddess Durga",
              videoId: "ODPCaLn2VrA",
              releaseDate: "2021"
            },
             {
              title: "Maiya Ke Dar Pe",
              description: "A devotional song calling devotees to the goddess Durga's abode",
              videoId: "K70ff3EUMPY",
              releaseDate: "2021"
            }

            // Add Durga devotional songs here
          ]
        },
        {
          name: "Wisdom",
          icon: "📿",
          songs: [
            {
              title: "Bhala Kisi Ka Kar Na Sako To",
              description: "A spiritual song about doing good to others",
              videoId: "zbZdajPCYuc",
              releaseDate: "2018"
            }
            // Add spiritual wisdom songs here
          ]
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
        <Helmet>
            <title>Original Music by Mukesh Rathore | Independent Music Composer</title>

            <meta
                name="description"
                content="Explore original music by Mukesh Rathore, an independent Indian music composer with 45+ original songs across romantic, devotional, family, patriotic, children’s, and instrumental genres."
            />

            <meta
                property="og:title"
                content="Original Music by Mukesh Rathore | Independent Music Composer"
            />

            <meta
                property="og:description"
                content="Original compositions by Mukesh Rathore spanning romantic, devotional, family, patriotic, children’s, and instrumental music."
            />            <link rel="canonical" href="https://mukeshrathore.com/music" />            </Helmet>

      <Navbar />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className={`bg-gradient-to-br ${currentTheme.colors.primary} text-white py-20 px-6`}>
          <div className="max-w-6xl mx-auto text-center">
            <motion.h1 
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-5xl md:text-7xl font-bold mb-6"
            >
              🎵 Original Songs
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-xl md:text-2xl text-purple-200 max-w-3xl mx-auto"
            >
              Listen to my original music creations. Stream directly here or find them on your favorite platforms.
            </motion.p>
          </div>
        </section>

        {/* Tabs and Songs */}
        <section className="py-20 px-6 bg-gray-50">
          <div className="max-w-6xl mx-auto">
            {/* Tabs */}
            <div className="flex gap-3 mb-12 overflow-x-auto pb-2">
              <div className="flex gap-3 mx-auto">
                {songCategories.map((category, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      setActiveTab(index);
                      setActiveFamilySubTab(0);
                      setActiveSubTab(0); // Reset sub-tab when switching main tabs
                    }}
                    className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap ${
                      activeTab === index
                        ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg transform scale-105'
                        : 'bg-white text-gray-700 hover:bg-gray-100 shadow'
                    }`}
                  >
                    <span className="mr-2">{category.icon}</span>
                    {category.category}
                  </button>
                ))}
              </div>
            </div>

            {/* Sub-Category Tabs */}
            {songCategories[activeTab].hasSubCategories && songCategories[activeTab].subCategories && (
              <div className="flex flex-wrap gap-2 mb-8 justify-center">
                {songCategories[activeTab].subCategories?.map((subCat, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveSubTab(index)}
                    className={`px-4 py-2 rounded-lg font-medium transition-all text-sm ${
                      activeSubTab === index
                        ? 'bg-purple-600 text-white shadow-md'
                        : 'bg-white text-gray-600 hover:bg-gray-100 shadow-sm'
                    }`}
                  >
                    <span className="mr-1">{subCat.icon}</span>
                    {subCat.name}
                  </button>
                ))}
              </div>
            )}

            {/* Active Category Content */}
            <motion.div
              key={`${activeTab}-${activeSubTab}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
            >
              {(() => {
                const currentCategory = songCategories[activeTab];
                const songsToDisplay = currentCategory.hasSubCategories
                  ? currentCategory.subCategories?.[activeSubTab]?.songs || []
                  : currentCategory.songs || [];

                return songsToDisplay.length > 0 ? (
                  <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
                    {songsToDisplay.map((song, index) => (
                      <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                        className="bg-white rounded-xl shadow-xl overflow-hidden hover:shadow-2xl transition-all"
                      >
                        <div className="p-6">
                          <div className="flex items-start justify-between mb-4">
                            <div>
                              <h3 className="text-2xl font-bold text-gray-800 mb-2">
                                {song.title}
                              </h3>
                              <p className="text-gray-600 mb-2">{song.description}</p>
                              <span className="text-sm text-purple-600 font-semibold">
                                Released: {song.releaseDate}
                              </span>
                            </div>
                          </div>
                          
                          {/* Embedded YouTube Player */}
                          <div className="mt-4">
                            <div className="relative" style={{ paddingBottom: '56.25%', height: 0 }}>
                              <iframe
                                src={`https://www.youtube.com/embed/${song.videoId}`}
                                title={song.title}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                className="absolute top-0 left-0 w-full h-full rounded-lg"
                              ></iframe>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-20">
                    <p className="text-gray-500 text-xl">No songs in this category yet. Coming soon!</p>
                  </div>
                );
              })()}
            </motion.div>

            {/* Call to Action */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mt-16"
            >
              <h3 className="text-3xl font-bold text-gray-800 mb-4">
                Want to create your own original songs?
              </h3>
              <p className="text-xl text-gray-600 mb-8">
                Join Indie Music Creators and learn the complete process in 90 days
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => window.open('/zoom', '_blank')}
                className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-8 rounded-lg text-lg transition-all shadow-xl"
              >
                Start Your Music Journey →
              </motion.button>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Music;
